import { ConsultationTypeEnum } from '@/shared/enums';
import { fetch } from '@/shared/fetch';

export const fetchMessageConsultationTypes = () => {
    return fetch<ConsultationTypeEnum[]>(
        '/api/caregiverspace/consultations/types/message',
    );
};
